import style from "./PersonalitySlider.module.css";

const PersonalitySlider = ({ label, leftLabel, rightLabel, value = 50 }) => {
  // Clamp value between 0 and 100
  const clampedValue = Math.max(0, Math.min(100, value));
  const percentage = clampedValue;

  return (
    <div className={style.sliderContainer}>
      <div className={style.labels}>
        <span className={style.leftLabel}>{leftLabel}</span>
        <span className={style.rightLabel}>{rightLabel}</span>
      </div>
      <div className={style.sliderTrack}>
        <div 
          className={style.sliderFill}
          style={{ width: `${percentage}%` }}
        />
        <div 
          className={style.sliderIndicator}
          style={{ left: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default PersonalitySlider;

